import { TableCell, TableCellProps } from '@mui/material'
import React from 'react'
import LinkWrapper from './LinkWrapper'

interface CustomTableCellProps extends TableCellProps {
    /**
     * If true, the cell will be rendered with a padding of 7px instead of 14px
     * @default false
     */
    isText?: boolean
    route?: string
    align?: 'left' | 'center' | 'right'
    disablePadding?: boolean
    maxWidth?: string | number
    center?: boolean
    multiline?: boolean
}

const CustomTableCell: React.FC<CustomTableCellProps> = ({
    isText,
    align,
    center,
    maxWidth,
    route,
    multiline,
    disablePadding,
    ...props
}: CustomTableCellProps) => {
    const alignment = center ? 'center' : align
    return (
        <TableCell
            {...props}
            style={{
                ...props.style,
                maxHeight: multiline ? 'auto' : '42px',
                maxWidth: maxWidth ?? '100%',
                paddingLeft: disablePadding ? 0 : (align === 'center' || center) ? '0px' : isText ? '14px' : '7px',
                paddingRight: disablePadding ? 0 : (align === 'center' || center || align === 'right') ? '13px' : '10px',
            }}
            padding='none'
            height={multiline ? 'auto' : '42px'}
            align={alignment ?? 'left'}
        >
            <LinkWrapper route={route}>
                <div style={{ height: '100%', width: '100%', display: 'flex', alignItems: 'center' }}>
                    <div
                        style={{
                            display: '-webkit-box',
                            overflow: 'hidden',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 2,
                            width: '100%',
                        }}
                    >
                        {props.children}
                    </div>
                </div>
            </LinkWrapper>
        </TableCell>
    )
}

export default CustomTableCell
